'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from '../../../internal/cx.js';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger, } from '../../../components/data-display/accordion/index.js';
/**
 * Frequently asked questions. Answer the question a buyer actually has; never
 * internal notes. Each question is a heading, so the list appears in the outline.
 */
export function FAQ({ items, headingAs = 'h3', multiple = false, defaultOpen, className, }) {
    const value = (i) => `faq-${i}`;
    const open = defaultOpen === undefined ? undefined : value(defaultOpen);
    const body = items.map((item, i) => (_jsxs(AccordionItem, { value: value(i), children: [_jsx(AccordionTrigger, { headingAs: headingAs, children: item.question }), _jsx(AccordionContent, { children: item.answer })] }, item.question)));
    return multiple ? (_jsx(Accordion, { type: "multiple", ...(open ? { defaultValue: [open] } : {}), className: cx('mn-faq', className), children: body })) : (_jsx(Accordion, { type: "single", collapsible: true, ...(open ? { defaultValue: open } : {}), className: cx('mn-faq', className), children: body }));
}
//# sourceMappingURL=marketing-section-blocks.faq.js.map